export default __webpack_public_path__ + "static/media/crate-items_v1_4.1af74637.jpg";